import React from 'react';

export default ({price, currency}) => {
  return `${currency} ${new Intl.NumberFormat('en-US', {
    maximumSignificantDigits: 3,
  }).format(price)}`;
};
